export const MATCH_CARD_COPY = {
  BOOST: 'Boost',
  BOOSTED: 'Boosted!',
  JOINED_MID_TOURNAMENT: 'Joined mid-tournament',
  // Shown in place of the points value while a finished pick is settled server-side
  // (pointsEarned still null) — avoids fabricating a wrong number from a local estimate.
  SCORING: 'Scoring…',
} as const;

export const TEAM_CODE: Record<string, string> = {
  Mexico: 'mx',
  'South Korea': 'kr',
  'South Africa': 'za',
  Denmark: 'dk',
  Canada: 'ca',
  Switzerland: 'ch',
  Qatar: 'qa',
  Italy: 'it',
  Brazil: 'br',
  Morocco: 'ma',
  Scotland: 'gb-sct',
  Haiti: 'ht',
  'United States': 'us',
  Australia: 'au',
  Paraguay: 'py',
  Romania: 'ro',
  Germany: 'de',
  Ecuador: 'ec',
  'Ivory Coast': 'ci',
  "Côte d'Ivoire": 'ci',
  Curaçao: 'cw',
  Curacao: 'cw',
  Netherlands: 'nl',
  Japan: 'jp',
  Tunisia: 'tn',
  Ukraine: 'ua',
  Belgium: 'be',
  Iran: 'ir',
  Egypt: 'eg',
  'New Zealand': 'nz',
  Spain: 'es',
  Uruguay: 'uy',
  'Saudi Arabia': 'sa',
  'Cape Verde': 'cv',
  'Cape Verde Islands': 'cv',
  'Czech Republic': 'cz',
  Czechia: 'cz',
  Sweden: 'se',
  'DR Congo': 'cd',
  'Congo DR': 'cd',
  'Democratic Republic of the Congo': 'cd',
  France: 'fr',
  Senegal: 'sn',
  Norway: 'no',
  Iraq: 'iq',
  Argentina: 'ar',
  Austria: 'at',
  Algeria: 'dz',
  Jordan: 'jo',
  Portugal: 'pt',
  Colombia: 'co',
  Uzbekistan: 'uz',
  Jamaica: 'jm',
  England: 'gb-eng',
  Croatia: 'hr',
  Panama: 'pa',
  Ghana: 'gh',
  TBD: 'xx',
};
